import { combineReducers } from "redux";

import config from "./config";

/**
 * Prueba para ver si agrupar por entidad tiene más sentido que por modulo.
 * algo más parecido a Entity
 */
import vendor from "./vendor";
import job from "./job";
import quote from "./quote";
import user from "./user";
import payment from "./payment";
import invoice from "./invoice";
import report from "./report";

import cache from "./cache";

import admin from "./admin";
import common from "./common";
import manager from "./manager";
import unrestricted from "./unrestricted";

const rootReducer = combineReducers({
    config,
    vendor,
    job,
    user,
    payment,
    invoice,
    report,
    cache,
    quote,

    admin,
    common,
    manager,
    unrestricted,
});

export default rootReducer;
